const formatDate = (raw?: string | null) => {
	if (!raw) return ""

	// native parse, use for ISO strings (.e.g May 30, 2025)
	const date = new Date(raw)
	if (!isNaN(date.getTime())) {
		const dd = String(date.getDate()).padStart(2, "0")
		const mm = String(date.getMonth() + 1).padStart(2, "0")
		const yyyy = date.getFullYear()
		return `${dd}/${mm}/${yyyy}`
	}

	// in case of extracting numeric parts from format as "30.05.2015", "30-05-2015"
	const numericMatch = raw.match(/(\d{1,2})[^\d](\d{1,2})[^\d](\d{2,4})/)
	if (numericMatch) {
		let [, dd, mm, yyyy] = numericMatch
		dd = dd.padStart(2, "0")
		mm = mm.padStart(2, "0")
		return `${dd}/${mm}/${yyyy}`
	}

	return raw
}

export default formatDate
